function insertSpacesFromPascalCase(str: string) {
  return str.replace(/(?!^)([A-Z])/g, " $1");
}

const stringHelper = {
  insertSpacesFromPascalCase,
};

export default stringHelper;
